import { ResponseRecord } from '../custom/element-submission.interface';
import { SurveyBundlePlugin } from '../survey-bundle/survey-bundle.interface';
import {
  IPluginVarConf,
  ISurveyPlugin,
  PluginContexts,
  SurveyPluginUsage,
} from './plugin.interface';

/**
 * The "Hydrated" plugin object.
 * This merges the specific instance/usage data with the base plugin definition.
 */
export interface ComposedSurveyPlugin {
  id: string;
  name: string;
  hooks: ISurveyPlugin['hooks'];
  html?: string;
  /**
   * The unique ID of this specific configuration instance (from SurveyPluginUsage)
   */
  usageId: string;
  /**
   * The actual configuration values applied to this instance.
   * This overrides the generic schema with real data.
   */
  instanceValues: Record<string, any>;

  /**
   * Contextual metadata from the usage record
   */
  context: {
    type: PluginContexts;
    surveyId: number | null;
    pageId: number | null;
    elementId: number | null;
  };
  variable_schema: IPluginVarConf;
  answerObject: ResponseRecord
}

export function composePlugin(
  usage: SurveyPluginUsage,
  definition: SurveyBundlePlugin,
  answerObject: ResponseRecord
): ComposedSurveyPlugin {
  definition.variable_schema;
  return {
    id: (definition as any).plugin_id || definition.id,
    name: definition.name,
    hooks: definition.hooks,
    html: definition.html,
    usageId: usage.id,
    instanceValues: usage.plugin_values,
    context: {
      type: usage.plugin_type,
      surveyId: usage.survey_id,
      pageId: usage.page_id,
      elementId: usage.element_id,
    },
    variable_schema: definition.variable_schema,
    answerObject
  };
}
